cd<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>

    <v-card-title>
      Investigation Referral Report
      <v-spacer></v-spacer>

      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-row>
        <v-col cols="12" sm="6" md="2">
          <template>
            <v-autocomplete
                :items="doctors"
                item-text="dr_name"
                item-key="id"
                item-value="id"
                label="Doctor List"
                v-model="doctor_id"
                outlined
                dense
            ></v-autocomplete>
          </template>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="date1"
                  label="Select Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hide-details
                  outlined
                  dense
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="date1"
                @input="menu1 = false"
                @click:date="dateSelect"
                :max="date2"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="date2"
                  label="Select End Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hide-details
                  outlined
                  dense
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="date2"
                @input="menu2 = false"
                @click:date="dateSelect"
                :max="nowDate"
                :min="date1"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              outlined
              dense
          ></v-text-field>
        </v-col>
        <v-col cols="1" class="ms-5">
          <v-btn
              depressed
              color="primary"
              append-icon="mdi-printer"
              v-on:click="printList"
          ><v-icon>mdi-printer </v-icon>Total Print
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card>

      <strong>Investigation Referral</strong>
      <v-data-table
          :headers="headers"
          :items="itemsWithSno"
          class="elevation-1"
          :search="search"
          dense
          mobile-breakpoint="0"
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
          :hide-default-footer="true"
          disable-pagination
      >
<!--        <template v-slot:item.invoice_refund_data="{ item }">-->
<!--          {{ item.invoice_refund_data.refund_amount }}-->
<!--        </template>-->
      </v-data-table>

      <strong>Summary </strong>
      <template v-if="total_summary" >
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">Title</th>
              <th class="text-left">Amount</th>
            </tr>
            </thead>
            <tbody>
            <tr>
            </tr>
            <tr>
              <td>Total Invoice Amount</td>
              <td v-if="total_summary">
                {{ total_summary.sub_total }}
              </td>
            </tr>
            <tr>
              <td>Total Received Amount</td>
              <td v-if="total_summary">
                {{ total_summary.paid_amount }}
              </td>
            </tr>
            <tr>
              <td>Total Discount Amount</td>
              <td v-if="total_summary">
                {{ total_summary.total_discount }}
              </td>
            </tr>
            <tr>
              <td>Total Referral Amount (%)</td>
              <td v-if="total_summary">
                {{ total_summary.total_dr_referral_amount }}
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </v-card>

  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
import moment from "moment";
export default {
  data() {
    return {
      dialog: false,
      date1: moment().format('YYYY-MM-DD'),
      date2: moment().format('YYYY-MM-DD'),
      nowDate: moment().format('YYYY-MM-DD'),
      menu1: false,
      menu2: false,
      loadingstatus: true,
      returnUrl: atshq.defaults.headers.common.app_URL,
      returnApiBaseURL: atshq.defaults.headers.common.api_base_URL,
      search: "",
      doctor_id: "",
      doctors: "",
      internal_doctor: "",
      internal_doctor_to: "",
      headers: [
        {
          text: "Serial #",
          value: "sno",
        },
        { text: "Invoice ID", value: "invoice_id" },
        { text: "Doctor", value: "referral_doctor.dr_name" },
        { text: "Invoice Amount", value: "sub_total" },
        { text: "Received", value: "paid_amount" },
        { text: "Discount Hospital(%)", value: "invoice_discount_hospital_percentage" },
        { text: "Discount Doctor(%)", value: "invoice_discount_doctor_percentage" },
        { text: "Total Discount", value: "discount_amount" },
        { text: "Refund", value: "invoice_refund_amount" },
        { text: "Referral Amount(%)", value: "dr_referral_amount" },
      ],
      desserts: [],
      total_summary: [],

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Invoices",
          disabled: true,
          href: "Invoices",
        },
      ],
    };
  },
  // Fetches posts when the component is created.

  watch: {
    dateSelect() {
      this.desserts = []
      if (this.dateSelect) {
        this.initialize()
      }
    },
    doctor_id() {
      this.initialize()
    }
  },
  created() {
    atshq.defaults.headers.common["Authorization"] = localStorage.getItem("token");
    this.initialize();
    this.getDoctors();
  },
  computed: {
    itemsWithSno() {
      return this.desserts.map((d, index) => ({ ...d, sno: index + 1 }));
    },
  },
  methods: {
    initialize() {
      atshq
          .get("investigation-referral-report?start_date=" + this.date1 + "&end_date=" + this.date2 + "&doctor_id="+ this.doctor_id)
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            this.desserts = response.data.referral_report;
            this.total_summary = response.data.total_summary;
          })
          .catch((e) => {
            // this.$noty.error("Oops, something went wrong!");
            this.$noty.error(" " + e);
            // this.errors.push(e);
          });
    },
    getDoctors() {
      atshq
          .get("doctors")
          .then((response) => {
            // JSON responses are automatically parsed.
            this.doctors = response.data.data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },

    getColor(status) {
      if (status == "void") return "red";
      else return "green";
    },
    internal_refer(item) {
      // window.open(this.returnUrl + "printdoc/invoice/" + item.invoice_id + "/1");
      this.internal_doctor = item;
      this.dialog = true;
    },
    invoice_print(item) {
      window.open(this.returnUrl + "printdoc/invoice/" + item.invoice_id + "/1");
    },

    invoice_gen(item) {
      this.$router.push("/invoice-create/" + item.patient_id);
      // console.warn(item);
    },
    dateSelect() {
      this.loadingstatus = true;
      console.log('start',this.date1)
      console.log('end',this.date2)
      this.initialize();
    },
    printList() {
      window.open(this.returnApiBaseURL + "print/investigation-referral-report?start_date=" + this.date1 +"&end_date="+this.date2 + "&doctor_id="+ this.doctor_id +"&user_id=" +
      localStorage.getItem("userId"));
    },
  },
};
</script>
